// extracted by mini-css-extract-plugin
export default {"wrapper-main":"pages_wrapper-main__LI5kv","wrapper-content":"pages_wrapper-content__KOTAI"};